<template>
  <v-container class="mt-1">
    <validation-observer v-slot="{ valid }">
      <base-material-card color="primary" icon="mdi-file-table-box-multiple-outline" inline class="ml-0 px-5 py-4">
        <template v-slot:after-heading>
          <div class="display-1 font-weight-light">Adicionar Grupo de Relatório</div>
        </template>
        <v-row class="mt-3">
          <v-col cols="12">
            <validation-provider v-slot="{ errors }" rules="required|max:30">
              <v-text-field
                id="nome-grupo-relatorios"
                v-model="titulo"
                label="Nome"
                outlined
                class="ml-4"
                :error-messages="errors"
                :loading="loading"
                :disabled="loading"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row class="mt-n6">
          <v-col cols="12" md="6" class="pt-0" />
          <v-col cols="12" md="6" class="pr-0">
            <v-btn
              id="btn-save-grupos-relatorios"
              class="mr-3"
              color="primary"
              min-width="100"
              style="float: right"
              :loading="loading"
              :disabled="!valid"
              @click="salvar()"
            >
              Salvar
            </v-btn>
          </v-col>
        </v-row>
      </base-material-card>
    </validation-observer>
  </v-container>
</template>

<script>
  import GruposRelatoriosService from '@/services/GruposRelatoriosService';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    mixins: [tourMixins],

    data: () => ({
      titulo: '',
      arrTour: [
        {
          element: '#nome-grupo-relatorios',
          intro: 'Aqui você deverá escolher um nome para seu grupo de relatórios modelos.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#btn-save-grupos-relatorios',
          intro:
            'Após o preenchimento / seleção dos critérios anteriores clique aqui para salvar seu grupo de relatórios modelos.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ],
      loading: false
    }),

    mounted() {
      if (this.$route.params.id) this.getGrupo(this.$route.params.id);
      this.iniciarTourPagina();
    },

    methods: {
      getGrupo(id) {
        this.loading = true;

        GruposRelatoriosService.getGrupoRelatorios(id)
          .then((response) => (this.titulo = response.data.data.titulo))
          .catch(() => this.$toast.error('Erro ao recuperar grupo de relatório.', '', { position: 'topRight' }))
          .finally(() => (this.loading = false));
      },

      salvar() {
        this.loading = true;
        let data = {
          id: this.$route.params.id ? this.$route.params.id : null,
          titulo: this.titulo
        };

        GruposRelatoriosService.salvar(data)
          .then(() => {
            this.$toast.success('Grupo de Relatório salvo com sucesso.', '', { position: 'topRight' });
            this.$router.replace({ name: 'Grupos Relatorios Historico' });
          })
          .catch(() => {
            this.$toast.error('Erro ao salvar grupo de relatório.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;
        this.iniciarTour(this.arrTour);
      }
    }
  };
</script>